import axios from 'axios';

const SILENT_LOG_KEY = '__LIT_SILENT_ERRORS__';

const serializeErrorArg = (arg) => {
  if (arg instanceof Error) {
    return {
      name: arg.name,
      message: arg.message,
      stack: arg.stack || null
    };
  }

  if (arg && typeof arg === 'object') {
    try {
      return JSON.parse(JSON.stringify(arg));
    } catch {
      return { value: String(arg) };
    }
  }

  return arg;
};

const logSilentError = (error) => {
  if (typeof window === 'undefined') return;

  try {
    const existing = Array.isArray(window[SILENT_LOG_KEY]) ? window[SILENT_LOG_KEY] : [];

    const entry = {
      timestamp: new Date().toISOString(),
      message: error?.message || 'Unknown error',
      status: error?.response?.status || null,
      url: error?.config?.url || null,
      method: error?.config?.method || null,
      response: serializeErrorArg(error?.response?.data)
    };

    existing.push(entry);
    // Keep only the latest 200 client errors.
    if (existing.length > 200) {
      existing.splice(0, existing.length - 200);
    }

    window[SILENT_LOG_KEY] = existing;
  } catch {
    // Silent by design.
  }
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/backend/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Asset base for static files (uploads). Defaults to production Hostinger site if not set.
// If REACT_APP_API_BASE_URL ends with '/backend/api', derive asset base by stripping that suffix.
export const API_BASE = process.env.REACT_APP_API_BASE_URL || '/backend/api';
const ASSET_BASE = process.env.REACT_APP_ASSET_BASE_URL || (typeof API_BASE === 'string' ? API_BASE.replace(/\/backend\/api\/?$/,'') : '') || 'https://lit.anibuss.com';

export const assetUrl = (filePath) => {
  if (!filePath) return '';
  if (!filePath.startsWith('/')) filePath = `/${filePath}`;
  return `${ASSET_BASE}${filePath}`;
};

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    logSilentError(error);

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
